module.exports = __webpack_public_path__ + "static/media/logo-black.cb8440be.svg";